module.exports = __webpack_public_path__ + "static/media/esc_logo.86b7bb63.png";